import styled from '@emotion/styled';

export const Header = styled.div();
